import { useGetUserGroupsQuery } from "../gateways/cms/userGroupApi";

import { styled } from "@mui/system";
import iconSelectDown from "../assets/icons/icon_arrow_down.svg";

export interface Props {
    value?: string;
    disabled?: boolean;
    required?: boolean;
    onChange?: (value: string) => unknown;
}

const SelectWithIcon = styled("select")`
    appearance: none;
    padding-right: 1.8em;
    border-radius: 0;
    background: transparent url(${iconSelectDown}) right center no-repeat scroll;    
`;

export function SelectUserGroup({ value = "", disabled = false, required = false, onChange = () => {} }: Props) {
    const userGroups = useGetUserGroupsQuery();

    let message = '権限データ取得中';
    if (userGroups.isFetching) {
        message = '権限データ取得中';
    }
    else{
        message = "未選択";
    }

    return (
        <SelectWithIcon value={value} disabled={disabled} required={required} onChange={(e) => onChange(e.target.value)}>
            <option value="">{message}</option>
            {userGroups.data?.map((userGroup) => (
                <option key={userGroup.id} value={userGroup.id}>
                    {userGroup.name}
                </option>
            ))}
        </SelectWithIcon>
    );
}
